import { useState } from 'react';
import { TooltipProvider } from '@monksflow/monks-ui';
import { FileCheckIcon, SparklesIcon, TrendingUpIcon } from 'lucide-react';
import {
  ListPageBody,
  ListPageLayout,
  PageHeader,
  PageHeaderIdentity,
  PageHeaderTitle,
  PageHeaderToolGroup,
} from '@/shared/ui/layout';
import { AboutPageDialog } from '@/shared/ui';
import { AnalysisListContent } from '@/features/analysis';
import { StaggerItem } from '@/shared/ui/animations';
import { useTranslation } from 'react-i18next';

export function AnalysisHome() {
  const { t } = useTranslation('analysis');

  const [isAboutOpen, setIsAboutOpen] = useState(false);

  const iq = t('analysisResult.analysisResult.iq');

  return (
    <TooltipProvider>
      <div data-testid="dashboard-layout-padded" className="page-layout">
        <ListPageLayout>
          {/* No description or filter toolbar here, so slots 1 and 2 are skipped and
              the content takes the shared content slot. */}
          <StaggerItem index={0}>
            <PageHeader>
              <PageHeaderIdentity>
                <PageHeaderToolGroup toolId="iq" category="plan">
                  <PageHeaderTitle info={{ onClick: () => setIsAboutOpen(true) }}>
                    {iq}
                  </PageHeaderTitle>
                </PageHeaderToolGroup>
              </PageHeaderIdentity>
            </PageHeader>
          </StaggerItem>

          <ListPageBody>
            <StaggerItem index={3} className="flex min-h-0 flex-1 flex-col">
              <AnalysisListContent />
            </StaggerItem>
          </ListPageBody>
        </ListPageLayout>

        <AboutPageDialog
          open={isAboutOpen}
          onOpenChange={setIsAboutOpen}
          title={t('analysisHome.about.title')}
          description={t('analysisHome.turnAudienceResearchIntoInsights')}
          rows={[
            { icon: SparklesIcon, text: t('analysisHome.about.clearFindings') },
            { icon: TrendingUpIcon, text: t('analysisHome.about.spotPatterns') },
            { icon: FileCheckIcon, text: t('analysisHome.about.buildTheCase') },
          ]}
        />
      </div>
    </TooltipProvider>
  );
}
